export default __webpack_public_path__ + "static/media/rtl_blue_cloud.1be06df3.png";